import { render, staticRenderFns } from "./ModalHeaderTitle.vue?vue&type=template&id=6c6a97bc&scoped=true"
import script from "./ModalHeaderTitle.vue?vue&type=script&lang=js"
export * from "./ModalHeaderTitle.vue?vue&type=script&lang=js"
import style0 from "./ModalHeaderTitle.vue?vue&type=style&index=0&id=6c6a97bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6a97bc",
  null
  
)

export default component.exports